import { render, staticRenderFns } from "./edit.themes.page.vue?vue&type=template&id=1a8b21b1&scoped=true&"
import script from "./edit.themes.page.vue?vue&type=script&lang=js&"
export * from "./edit.themes.page.vue?vue&type=script&lang=js&"
import style0 from "./edit.themes.page.vue?vue&type=style&index=0&id=1a8b21b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8b21b1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardTitle,VDialog,VIcon})
